<template>
  <!-- 面板 -->
  <div class="pack">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'Pack',
}
</script>

<style lang="scss">

.pack{
  position: relative;
  background-color: #FFF;
  border: 1px solid $theme-border3;
  border-radius:4px;
  padding: 32px;
  margin-bottom: 16px;
  overflow: hidden;
}
</style>